(function () {
  'use strict';

  angular
    .module('app.insightReportBenchmark')
    .controller('insightReportBenchmarkCtrl', insightReportBenchmarkCtrl);

  insightReportBenchmarkCtrl.$inject = ['measureService', 'insightReportBenchmarkService', '$scope', '$rootScope'];
  function insightReportBenchmarkCtrl(measureService, insightReportBenchmarkService, $scope, $rootScope) {

    $scope.$on('refreshDashboard', function(event, args) {
      getDataInsightReportBenchmark();
    });

    $scope.verticalListBechmark = [];
    $scope.openedVerticalSelection = false;

    $scope.openVertical = function($event,option) {
        $event.preventDefault();
        $event.stopPropagation();

        $scope.openedVerticalSelection = !$scope.openedVerticalSelection;
    };

    var enableWatchBenchmark = false;
    var benchmarkPerformanceData = null;

    $scope.$watch('selectedVerticalBenchmark', function(newValue, oldValue){
      if(enableWatchBenchmark && newValue !== oldValue && newValue !== undefined && newValue.length != 0){        
        var indexNo = 0;
        for(var i = 0; i < $scope.verticalListBechmark.length; i++){
          if(newValue[0].name.localeCompare($scope.verticalListBechmark[i].name) == 0){
            indexNo = i;
          }
        }

        if(benchmarkPerformanceData != null && benchmarkPerformanceData !== undefined && benchmarkPerformanceData.length > 0){
          if(benchmarkPerformanceData[0].menu.nameRight != "NA"){
            generateBenchmarkPerformance(benchmarkPerformanceData, indexNo);
          } else{
            indexNo += 1;
            generateBenchmarkPerformance(benchmarkPerformanceData, indexNo);
          }
        }
      }
    });

    function generateBenchmarkPerformance(benchmarkPerformance, indexNo) {
        $scope.benchmarkPerformance = benchmarkPerformance[indexNo];        
    }

    function getDataInsightReportBenchmark() {
      var params = $rootScope.saveParams;
      if(params == null || (params.mention == 0 && params.blog_id == 0 && params.project_id == 0 && params.channel == 0 && params.influencerGroup == 0)) {
        return;
      }
      params.date = 30;
      
      getBenchmarkPerformanceData(params);
    }

    function getBenchmarkPerformanceData(params){
      insightReportBenchmarkService.getBenchmarkPerformanceData(params)
        .then(function(response){
            benchmarkPerformanceData = response.benchmarkPerformance;
            //Check if the first menu is "NA"
            if(response.benchmarkPerformance[0].menu.nameRight != "NA"){
              generateBenchmarkPerformance(response.benchmarkPerformance, 0);
            } else{
              generateBenchmarkPerformance(response.benchmarkPerformance, 1);
            }
            $scope.verticalListBechmark = [];
            angular.forEach(response.benchmarkPerformance, function(item){
              var tempItem = {name: item.menu.nameRight.toUpperCase()};
              if(tempItem.name != "NA"){
                $scope.verticalListBechmark.push(tempItem);
              }
              
              if($scope.verticalListBechmark.length > 1){
                enableWatchBenchmark = true;
              };
            })   
        })
        .catch(function(message){
          benchmarkPerformanceData = [];
          $scope.benchmarkPerformance = [];
          $scope.verticalListBechmark = [];
        })
        .finally(function(){
          $rootScope.$broadcast('sectionLoaded');
        })            
    }

    // first initiating
    getDataInsightReportBenchmark();
  }
})();